import { statusMessages } from '@app/modules/logger/screens/status/components/options';
import { StatusBadge, StatusIcon } from '@mi-front/ui';
import { useIntl } from 'react-intl';

interface Props {
  readonly isOnline: boolean;
  readonly compact?: boolean;
}

/**
 * Status indicator: StatusIcon in tighter grids, full badge in list and gridWide.
 */
export function StatusIndicator(p: Props) {
  const { $t } = useIntl();
  const { isOnline, compact = false } = p;

  if (compact) {
    return <StatusIcon status={isOnline} size="medium" />;
  }

  return (
    <StatusBadge
      size="medium"
      status={isOnline}
      onText={$t(statusMessages.online)}
      offText={$t(statusMessages.offline)}
    />
  );
}
